import BasicUserInfo from "../BasicUserInfo";

function ReportReason({ nightMode, reportMessage }) {
  if (!reportMessage) {
    return null;
  }
  return (
    <div className="flex flex--gap-small">
      <BasicUserInfo
        userId={reportMessage.userId}
        nightMode={nightMode}
        isTiny={true}
      />
      <p className="description--small bold">{reportMessage.reason}</p>
      {reportMessage.message ? (
        <p className="description--small italic break-long-words white-space">
          {reportMessage.message}
        </p>
      ) : null}
    </div>
  );
}

export default ReportReason;
